<template>
  <teleport to="body">
    <div id="common-modal" ref="modal" class="modal common-modal" role="dialog">
      <div
        class="common-modal__modal-box modal-dialog"
        :class="{
          'common-modal__modal-box--no-padding': compact,
          'common-modal__modal-box--bottom-aligned': bottomAligned
        }"
        v-bind="$attrs"
      >
        <button
          v-if="!hideCloseButton"
          class="common-modal__modal-button-close"
          :class="{ 'common-modal__modal-button-close--no-bg': compact }"
          type="button"
          @click="close"
        >
          <UseSvg class="common-modal__modal-button-close-icon" icon="menu-close" />
        </button>
        <div v-if="title" class="common-modal__modal-header" role="heading" tabIndex="0">
          <span class="common-modal__title">{{ title }}</span>
        </div>
        <slot></slot>
      </div>
    </div>
  </teleport>
</template>
<script>
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

export default {
  name: "CommonModal",
  components: { UseSvg },
  props: {
    title: {
      type: String,
      default: undefined
    },
    compact: {
      type: Boolean,
      default: false
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    bottomAligned: {
      type: Boolean,
      default: false
    }
  },
  emits: ["on-close"],
  computed: {
    $$modal() {
      return $(this.$refs.modal);
    }
  },
  mounted() {
    this.onShow();
  },
  methods: {
    onShow() {
      this.$$modal.modal("show").on("hidden.bs.modal", e => {
        this.$$modal.off("hidden.bs.modal");
        if (e.target.id === this.$$modal[0].id) {
          this.$emit("on-close");
          this.close();
        }
      });
    },
    close() {
      this.$$modal.modal("hide");
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.common-modal {
  &.modal {
    z-index: 10000;
  }

  &__modal-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 2px;
    padding: 5px;
    margin: 0 !important;
    height: fit-content;
    width: fit-content !important;
    max-width: 95vw;
    max-height: 95vh;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) !important;
    box-shadow: $block-shadow 0px 8px 24px;

    @include with-desktop {
      border-radius: 8px;
      padding: 32px;
      height: auto;
    }

    &--no-padding {
      padding: 0;
    }

    &--bottom-aligned {
      max-width: 100vw;
      top: auto;
      bottom: 0;
      transform: translate(-50%, 0) !important;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;

      @include with-tablet {
        max-width: 95vw;
        top: 50%;
        bottom: unset;
        transform: translate(-50%, -50%) !important;
      }
    }
  }

  &__modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 5px;
  }

  &__title {
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: $gray-modern-700;
  }

  &__modal-button-close {
    position: absolute;
    padding: 0;
    background-color: $black-transparent;
    border-radius: 50%;
    border-style: none;
    right: 8px;
    top: 8px;
    color: $white;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;

    &--no-bg {
      background-color: transparent;
      color: $text-black;
    }
  }

  &__modal-button-close-icon {
    width: 20px;
    height: 20px;
  }
}
</style>
